import { KYMW9100Model } from '../kymw9100.model';
import { PlessViewUtilsSub } from './../../../../commons/kymw00/pless-view-utils-sub.service';
import { LogSearchConditionModel } from '../vo/log-search-condition-model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ログ検索画面　ログデータ取得サービス
 *
 * @export GetLogDataService
 * @class GetLogDataService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetLogDataService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9100Model;
  private successFunc: Function;
  private vo: LogSearchConditionModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetLogDataService
   */
  private getBody(): PlessRequest {
    let parameter: any = {};

    if (!PlessViewUtilsSub.isEmpty(this.vo.orderCode)) {
      parameter["OrderCode"] = this.vo.orderCode;
    }
    if (!PlessViewUtilsSub.isEmpty(this.vo.pcode)) {
      parameter["PCode"] = this.vo.pcode;
    }
    if (!PlessViewUtilsSub.isEmpty(this.vo.itemCode)) {
      parameter["ItemCode"] = this.vo.itemCode;
    }
    if (!PlessViewUtilsSub.isEmpty(this.vo.userID)) {
      parameter["UserID"] = this.vo.userID;
    }
    if (!PlessViewUtilsSub.isEmpty(this.vo.updateDateFrom)) {
      parameter["UpdateDateFrom"] = this.vo.updateDateFrom;
    }
    if (!PlessViewUtilsSub.isEmpty(this.vo.updateDateTo)) {
      parameter["UpdateDateTo"] = this.vo.updateDateTo;
    }
    if (this.vo.pageNum > 0) {
      parameter["PageNum"] = String(this.vo.pageNum);
    }
    if (!PlessViewUtilsSub.isEmpty(this.vo.sortColumnName)) {
      parameter["SortColumnName"] = this.vo.sortColumnName;
    }
    if (!PlessViewUtilsSub.isEmpty(this.vo.sortKind)) {
      parameter["SortKind"] = this.vo.sortKind;
    }

    let combination: any[] = [];
    if (!PlessViewUtilsSub.isEmptyArray(this.vo.coopCodeList)) {
      for (const coopCode of this.vo.coopCodeList) {
        const param = {
          parameter: {
            CoopCodeList: coopCode,
          }
        }

        combination.push(param);
      }
    }

    parameter["SearchTableCondition"] = String(this.vo.searchTableCondition);

    return new PlessRequest({
      search: {
        GetLogData: {
          parameter,
          combination,
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9100Model} model
   * @param {LogSearchConditionModel} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetLogDataService
   */
  execute(model: KYMW9100Model, vo: LogSearchConditionModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getLogData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetKYMW9100ListService
   */
  success(data: any) {
    this.model.commitData(data);
    // 画面上の検索総件数、表示行番号(From)、表示行番号(To)を再表示する。

    // 「前へ」ボタンを非活性化する。
    // ①	表示行番号(From) = 1の場合、「前へ」ボタンを非活性化する。
    if (Number(this.model.rowCntFrom) === 1) {
      this.model.prevDisabled = true;
    } else if (Number(this.model.rowCntFrom) > 2) {
      // ②	表示行番号(From) > 2の場合、「前へ」ボタンを活性化する。
      this.model.prevDisabled = false;
    }

    // 「次へ」ボタンを活性　又は非活性とする。
    // ①	検索総件数＞表示行番号(To)の場合、「次へ」ボタンを活性化する。
    if (Number(this.model.totalNum) > Number(this.model.rowCntTo)) {
      this.model.nextDisabled = false;
    } else if (Number(this.model.totalNum) <= Number(this.model.rowCntTo)) {
      // ②	検索総件数＝表示行番号(To)の場合、「次へ」ボタンを非活性化する。
      this.model.nextDisabled = true;
    }

    // 「出力」ボタンをを活性　又は非活性とする。
    // ①　検索総件数＞０の場合、活性化する。
    if (Number(this.model.totalNum) > 0) {
      this.model.printOutDisabled = false;
    } else {
      // ②　検索総件数＝０の場合、非活性化する。
      this.model.printOutDisabled = true;
    }
  }

  public plessErrorHandler(errList: any): void {
    // 総件数が0件の場合、エラー表示。
    // (メッセージID：E0100)

    this.model.accessLogList = new Array<any>();

    // 件数のクリア
    this.model.rowCntFrom = 0;
    this.model.rowCntTo = 0;
    this.model.totalNum = 0;

    // 画面の「前へ」「次へ」「出力」ボタンを非活性にする
    this.model.nextDisabled = true;
    this.model.prevDisabled = true;

    // ※「出力」ボタンは閲覧権限でも実行できるため、ここでは強制的にfalseにする
    this.model.printOutDisabled = true;
    super.plessErrorHandler(errList);
  }

}
